import { render } from "./UpdatePassword.vue?vue&type=template&id=1c01b456&scoped=true"
import script from "./UpdatePassword.vue?vue&type=script&lang=js"
export * from "./UpdatePassword.vue?vue&type=script&lang=js"

import "./update-password.scss?vue&type=style&index=0&id=1c01b456&lang=scss&scoped=true"

import exportComponent from "/var/www/html/HR/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c01b456"]])

export default __exports__